import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import OrganisationSettingsPageHeader from '@/modules/admin-center/organisation-settings/OrganisationSettingsPageHeader'
import { ROUTE_PARAMS } from '@/routes/routes'

const AllOrganisations = lazy(() => import('@/modules/organisations/OrganisationsList'))
const OrganisationSettingsAccounts = lazy(
  () => import('@/modules/admin-center/organisation-settings/accounts/OrganisationSettingsAccounts')
)
const OrganisationAuditLog = lazy(
  () => import('@/modules/admin-center/organisation-settings/audit-log/OrganisationAuditLog')
)
const OrganisationSettingsDeliveryAddresses = lazy(
  () => import('@/modules/admin-center/organisation-settings/delivery-addresses/OrganisationSettingsDeliveryAddresses')
)
const OrganisationSettingsGeneral = lazy(
  () => import('@/modules/admin-center/organisation-settings/general/OrganisationSettingsGeneral')
)
const OrganisationSettingsInvoicing = lazy(
  () => import('@/modules/admin-center/organisation-settings/invoicing/OrganisationSettingsInvoicing')
)
const CreateNewOrganisation = lazy(() => import('@/modules/organisations/CreateNewOrganisation'))
export default function OrganisationRoutes() {
  // base path /organisations
  return (
    <Routes>
      <Route path="/" element={<AllOrganisations isPurchasers />} />
      <Route path="/create" element={<CreateNewOrganisation isPurchaser />} />
      <Route path={`/${ROUTE_PARAMS.ORGANISATION}`} element={<OrganisationSettingsPageHeader isFromOrganisationList />}>
        <Route path="general" element={<OrganisationSettingsGeneral />} />
        <Route path="invoicing" element={<OrganisationSettingsInvoicing />} />
        <Route path="delivery-addresses" element={<OrganisationSettingsDeliveryAddresses />} />
        <Route path="accounts" element={<OrganisationSettingsAccounts />} />
        <Route path="audit-log" element={<OrganisationAuditLog />} />
      </Route>
    </Routes>
  )
}
